<div
  [id]="task().id"
  class="group grid grid-cols-[auto_1fr] p-2 hover:bg-gray-100 has-[.router-link-active]:bg-celeste-blue-50"
>
  <div
    class="col-start-1 row-span-full w-0 border-0 border-solid group-hover:border-2 group-hover:border-gray-800 group-has-[.router-link-active]:border-2 group-has-[.router-link-active]:border-r1-blue-500"
  ></div>
  <a
    [routerLink]="task().routerLinkPath"
    queryParamsHandling="preserve"
    routerLinkActive="router-link-active"
    class="task-link col-span-full row-span-full block select-none ps-3.5 !text-current no-underline"
    (dragstart)="$event.preventDefault()"
    (click)="sidebarState.selectTask()"
  >
    @switch (task().taskType) {
      @case (taskTypes.MailPackageTaskItem) {
        <ri-resolution-ui-mail-package-task-template
          [task]="task()"
        ></ri-resolution-ui-mail-package-task-template>
      }
      @case (taskTypes.CallPayerTaskItem) {
        <ri-resolution-ui-call-payer-task-template
          [task]="task()"
        ></ri-resolution-ui-call-payer-task-template>
      }
      @case (taskTypes.CreatePackageTaskItem) {
        <ri-resolution-ui-create-package-task-template
          [task]="task()"
        ></ri-resolution-ui-create-package-task-template>
      }
      @case (taskTypes.PayerPortalTaskItem) {
        <ri-resolution-ui-payer-portal-task-template
          [task]="task()"
        ></ri-resolution-ui-payer-portal-task-template>
      }
      @case (taskTypes.ReviewTaskItem) {
        <ri-resolution-ui-review-task-template
          [task]="task()"
        ></ri-resolution-ui-review-task-template>
      }
      @case (taskTypes.ManualPortalTaskItem) {
        <ri-resolution-ui-manual-portal-task-template
          [task]="task()"
        ></ri-resolution-ui-manual-portal-task-template>
      }
      @default {
        Unknown task type
      }
    }
  </a>
</div>
